function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sun"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 5c.552 0 1-.448 1-1v-1c0-.552-.448-1-1-1s-1 .448-1 1v1c0 .552.448 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.636 7.05c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-.707-.707c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 12c0-.552-.448-1-1-1h-1c-.552 0-1 .448-1 1s.448 1 1 1h1c.552 0 1-.448 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.636 16.949-.707.707c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l.707-.707c.391-.391.391-1.023 0-1.414s-1.024-.39-1.414 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 19c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1s1-.448 1-1v-1c0-.553-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.363 16.95c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.707.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 11h-1c-.552 0-1 .448-1 1s.448 1 1 1h1c.552 0 1-.448 1-1s-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.656 7.343c.256 0 .512-.098.707-.292l.708-.707c.391-.391.391-1.024 0-1.415s-1.024-.39-1.415 0l-.708.707c-.391.391-.391 1.024 0 1.415.196.195.452.292.708.292z"
})));

var Svg117Sun = function Svg117Sun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg117Sun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/117-sun.abf48e44.svg";
export { ForwardRef as ReactComponent };